import React, { useState, useEffect } from 'react';
import './GalleryDescription.css'
import {  Link } from "react-router-dom";

const GalleryDescription = ({ description, title,gallery,  mediaItems = [] }) => {

  return (
    <>
      <div className='flex col align'>
        <div className="video-container">
          <video  id="bg-video" className='desktop'  src="./videos/Capa_website_V02.mp4" autoPlay muted loop type="video/mp4"/>
          <video  id="bg-video" className='mobile'  src="./videos/Capa_website_V02.mp4" autoPlay muted loop type="video/mp4"/>
        </div>
        <div className='gradient-text algin center-content center-text'><h2>{title}</h2></div>
          <div className='center-content algin center-text'>{description}</div>
      
        <div className='flex align row center-content breakline top30 bot50 padbot150'>
          {mediaItems.map((media) => (
            <Link className='desc-image' to={media.gallery}>
            <img className='rotate fill round15' src={media.thumbnail}/>
            </Link>
            )) 
            
            }
          
          
        </div>
      </div>
    </>

  );
}
export default GalleryDescription;